<template>
	<div id="">
		<div >
			<div style="padding: 0 220px 20px;">
				<div class="list_box" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled">
					<div class="type_size_22" v-html="item.title"></div>
					<div class="p_flex p_f_a p_f_b p_m_t_20">
						<div class="p_flex type_size_16">
							<span class="subject_color">{{item.grade_def}}</span>
							<el-divider direction="vertical"></el-divider>
							<span class="subject_yellow">{{item.subject_def}}</span>
							<el-divider direction="vertical"></el-divider>
							<span>{{item.question_type_def }}</span>
							<el-divider direction="vertical"></el-divider>
							<span>{{item.score}}分</span>
						</div>
						<div class="p_flex">
							<el-checkbox-group v-model="checkedCities"  @change="change">
								<el-checkbox :label='item.id' :checked='ids.indexOf(item.id)>=0 ' >{{""}}</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
				</div>
			</div>
			<pagination @get="get" :index="num"/>
		</div>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue'
export default {
	props: {
		dataInfo: Object,
		ids:Array
	},
	data() {
		return {
			count:[],
			num:0,
			page:1,
			checkedCities:[],
			newVar:[]
		};
	},
	watch: {},
	components: {
		pagination
	},
	created() {
		this.getPag();
		// this.newVar = this.checkedCities
		this.$parent.nvl = this.checkedCities
	},
	mounted() {},
	methods: {
		get(i) {
			this.page  = i
			this.getPag();
		},
		getPag(){
			this.$request
				.ajax(this)
				.post('/api_teacher/question_list', {
					belonging: this.dataInfo.belonging, // 1 学校题库 2 我的题库
					grade: this.dataInfo.gradeTypes, //年级
					subject: this.dataInfo.subjectTypes,//学科
					page:this.page,
					limit:10
				})
				.then(res => {
					this.count = res.data.list;
					this.num = res.data.count;
				});
		},
		change(e){
			console.log(e)
			this.$emit('change',e)
		},

	}
};
</script>

<style lang="scss" scoped>
	.list_box {
		padding: 20px 0;
		border-bottom: 1px solid #e6e6e6;
		margin: 0 20px;
	}
	>>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		border-color: #00af63;
		background: #00af63;
	}
	>>> .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #00af63;
	}
	>>> .el-checkbox__inner {
		width: 18px;
		height: 18px;
	}
	>>> .el-checkbox__label {
		font-size: 18px;
	}
	>>> .el-checkbox__inner:hover {
		border-color: #999999;
	}

	>>>.el-checkbox__inner::after {
	    height: 9px;
	    left: 6px;
	    top: 1px;
	    width: 4px;
	}
</style>



// WEBPACK FOOTER //
// src/components/homet/exercises/commponents/list.vue